<template>
  <div id="main-wrapper" class="inner-pages page-not-found">
    <div class="section contact-content">
      <img src="/assets/images/page-not-found.gif" alt="page not found" title="page not found" width="500" height="500" class="fluid-img" />
      <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
      <a href="/" class="btn btn-blue">Go to AAAFx Homepage</a>
    </div>
  </div>
</template>